import Axios from "axios";
import React from "react";
import { Spin } from "../loading";
import { BarChart } from "../bar-chart";
import { LineChart } from "../line-chart";

interface ProgrammeOverviewProps {}

interface State {
  lineChart: unknown[];
  pieChart: unknown[];
  barChart: unknown[];
  loading: boolean;
}

export const ProgrammeOverview: React.FC<ProgrammeOverviewProps> = (props) => {
  const [state, setState] = React.useState<State>({
    lineChart: [],
    pieChart: [],
    barChart: [],
    loading: false,
  });

  React.useEffect(() => {
    setState({ ...state, loading: true });
    Axios.get(`/programme/overview`)
      .then((res) => {
        const { lineChart, barChart } = res.data;
        setState({
          ...state,
          lineChart: [{ label: "Programme", data: lineChart[0] }],
          barChart: [{ label: "Programme", data: barChart[0] }],
        });
      })
      .finally(() => {
        setState((prev) => ({ ...prev, loading: false }));
      });
  // eslint-disable-next-line
  }, []);

  return (
    <div className="overview">
      <span className="title">programme overview</span>

      <div className="contract">
        {/* <span className="title">This Contract</span> */}
        <Spin spin={state.loading}>
          <LineChart data={state.lineChart} />
        </Spin>
      </div>

      <div>
        <span className="title">Latest Month</span>
        <div className="latest">
          <Spin spin={state.loading}>
            <BarChart data={state.barChart} />
          </Spin>
        </div>
      </div>
    </div>
  );
};
